import axios from 'axios'
import React, { useState } from 'react'
import './FacultyLogin.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom'
import { toastConfig } from '../../../../utils/ToastConfig'
import { BsEyeSlash, BsEye } from "react-icons/bs";

const FACULTY_LOGIN_URL = '/faculty/login'

const FacultyLogin = () => {
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const [showPass, setShowPass] = useState(false)

    const faculty = localStorage.getItem('faculty_token')

    const submitHandler = (e) => {
        e.preventDefault();
        let data = { email, password }
        setLoading(true)
        axios.post(process.env.REACT_APP_DEPT_API + FACULTY_LOGIN_URL, data).then((res) => {
            setLoading(false)
            let data = res.data
            if (data.status === "ok" && data.faculty_token) {
                localStorage.setItem("user_id", data.id)
                localStorage.setItem("faculty_token", data.faculty_token)
                toast.success("Login sucessfull", toastConfig)
                navigate(`/faculty/${data.id}`)
            }
            else if (data.status === "error") {
                toast.error(data.error, toastConfig);
                setPassword('')
            } else {
                toast.error(data.error, toastConfig);
            }
        }).catch(err => {
            alert(err.message)
        })
    }

    const logout = () => {
        const authToken = localStorage.getItem('faculty_token')
        const user_id = localStorage.getItem('user_id')
        if (!authToken || !user_id) {
            toast.error("not logged in", toastConfig)
        } else {
            localStorage.removeItem('faculty_token')
            localStorage.removeItem('user_id')
            localStorage.removeItem('club_token')
            navigate('/faculty/login')
        }
    }

    const toggleShowPass = () => {
        setShowPass(!showPass)
    }

    return (
        <div className='auth__container'>
            <ToastContainer
                position="bottom-right"
                autoClose={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                theme="colored"
            />
            <h1 className='section__header'>Faculty Login</h1>
            {faculty ?
                <div>
                    <p className='about__p'><b>You are already logged in</b></p>
                    <button className='admin_btn' onClick={logout}>Logout</button>
                </div>
                :
                <div className='facultylogin_card'>
                    <form onSubmit={submitHandler} className='facultylogin_form'>
                        <h1>Welcome Back!</h1>
                        <p>Please Log in to your faculty account.</p>
                        <div className='auth_input_div'>
                            <label className='auth__label'>Email</label>
                            <input className='auth__input' type="email" placeholder="teacher@gmail.com" value={email} onChange={e => setEmail(e.target.value)} />
                        </div>
                        <div className='auth_input_div'>
                            <label className='auth__label'>Password</label>
                            <input className='auth__input' type={showPass ? 'text' : 'password'} placeholder="*********" value={password} onChange={e => setPassword(e.target.value)} />
                            {showPass ? <BsEye className='auth_input_eye' onClick={toggleShowPass}/> : <BsEyeSlash className='auth_input_eye' onClick={toggleShowPass}/>}
                        </div>
                        <button disabled={loading ? true : false} className='auth__btn' type="submit">
                            {loading ? "Logging in..." : "Log in"}
                        </button>
                    </form>
                </div>}
        </div>
    )
}

export default FacultyLogin